module.exports = "/images/Submit to design.svg";